export const colors = {
  // Core Colors
  blueBase: '#3f73f5',
  blueDark: 'rgba(63, 115, 245, 1)',
  primary: '#007bff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
  veryDarkGray: '#1E1E1E',

  // Grays
  grayLight: '#7A7A7A',
  grayMedium: '#595959',
  grayDark: '#515151',
  grayLighter: '#cccccc59',
  grayDarker: '#cccccc',
  graySurface: '#EEEEEE',
  grayBorder: '#ddd',
  grayTitle: '#1A3067',
  grayBody: '#6B7280',
  greyDisabled: '#B3B3B3',
  grayDarkDisabled: '#A9A9A9',
  lightGrayShade: '#ABABAB',
  lightGrey: '#ddd',
  darkGray: '#111928',
  lightGray: '#D1D5DB',

  // Blues
  blueDarkText: '#233F87',
  blueIcon: '#658FF7',
  blueRoyal: '#3f73f51a',
  yellow: '#FCDF8A',
  blueRoyalDark: '#2D52AE',
  blueBorderLight: '#C3D4FC',
  blueActiveBg: '#1C64F2',
  blueButtonLight: '#a7bffa',
  blueChipBg: '#ECF1FE',
  blueSoft: '#A7BFFA',

  // Icon Colors
  iconSearch: '#3F73F5',
  iconChevronDown: '#3F3F3F',
  iconEdit: '#7EA1F8',
  iconTrash: '#FD9C9C',
  iconSearchGray: '#909090',
  iconGreen: '#47C651',
  iconRed: '#FC5353',
  iconYellow: '#FAD154',
  iconDarkRed: '#E02424',

  // Charts & Counts
  chartUserGrowthBorder: '#4caf50',
  chartUserGrowthBg: 'rgba(76, 175, 80, 0.1)',
  chartVerificationRateBorder: '#2196f3',
  chartVerificationRateBg: 'rgba(33, 150, 243, 0.1)',
  countMale: '#1a3067',
  countFemale: '#8a1616',
  countOther: '#886600',

  // Tags & Chips
  chipBgLightBlue: '#f0f4f8',

  // Button States
  buttonHover: '#0056b3',
  buttonDisabledBg: '#ecf1fe',
  buttonDisabledText: '#808080cc',

  // Decorative Colors
  graphContainerBorder: '#F1F1F1',
  pink: '#FFA5CB',
  pinkDark: '#F765A3',
  pinkLight: '#E697FF',
  purple: '#7987FF',
  purpleLight: '#A155B9',
  greenBright: '#19B826',
  mintGreen: '#65CF6E',
  paleMint: '#E8F8E9',
  forestGreen: '#0B4D10',
  royalBlueDark: '#2D52AE',
  DarkGrayLight: '#313131',
  blueTick: '#4fc3f7',
  orange: '#FFEAEA',
  orangedark: '#691111',
  darkgray: '#252525',
  vividRed: '#e02424',
  redDark: '#ff4d4f',
  redBright: '#FF3B30',
  blackOlive: '#3f3f3f',
  blackChocolate: '#0A0A0A',
  brightGray: '#EDEDED',
  shadeGray: '#4A4A4A',
  grayShadeLight: '#1C1C1C',
  darkGrayLight: '#313131',
  iceBlue: '#EDF6FE',
  deepBlue: '#003882',
  jetBlack: '#0E0E0E',
  paleSkyBlue: '#CBDDEA'
};

export default colors;
